import api from "./axios";
import type { IncomeSource, HouseholdIncome } from "./types";

export const incomeService = {
  getAll: (params: { userId?: string; month?: number | "all"; year?: number | "all" }) =>
    api.get<HouseholdIncome>("/incomes", { params }).then(r => r.data),
  add: (d: { label: string; amount: number; month: number; year: number }) =>
    api.post<IncomeSource>("/incomes", d).then(r => r.data),
  update: (id: string, d: { label: string; amount: number; month: number; year: number }) =>
    api.put<IncomeSource>(`/incomes/${id}`, d).then(r => r.data),
  remove: (id: string) => api.delete(`/incomes/${id}`).then(r => r.data),
};